import React, {useState} from 'react';
import Translate, {t} from '../../../../../components/Translate';
import PeakHoursStatistics from "./components/graphs/PeakHoursStatistics";
import OperatorWorkingHours from "./components/operators/OperatorWorkingHours";
import CategoriesStatistics from "./components/graphs/CategoriesStatistics";
import StatisticsConvModal from "../../../../../components-new/general/statistics/StatisticsConvModal";
import {
    clearSelectedConversation as clearSelectedConversationFromStore,
    loadOlderMessagesRequested,
    selectConversationRequested
} from "../../../../../services/chat/action";
import {connect} from "react-redux";
import SelectedConversationHistory from "../history/ConversationHistory";
import OperatorsTable from "./components/operators/OperatorsTable";
import config from "../../../../../config";
import OperatorsLoginLogoutTable from "./components/operators/OperatorsLoginLogoutTable";
import BotRequestsStatistics from "./components/requestsToBots/BotRequestsStatistics";
import OperatorsRequestsStatistics from "./components/requestsToOperators/OperatorsRequestsStatistics";
import DropdownSelect from "../../../../../components-new/form/DropdownSelect";
import Tabs from "../../../../../components-new/ui/Tabs";
import PlatformIcon from "../../../../../components-new/general/PlatformIcon";
import BotAvatar from "../clients/new/overview/BotAvatar";

function Statistics2(props) {
    const {
        user,
        conversation,
        clearSelectedConversationFromStore,
        selectConversation,
        company,
        loadOlderMessages,
        companyInfoList,
        categoriesStatisticsData,
        statNumbers,
        isFetchingNumbers,
        isFetchingCompanyInfo,
        peakHoursStatisticsData,
        filterPeakHoursData,
        operatorsWorkTimeData,
        whStartDate,
        whEndDate,
        setWhStartDate,
        setWhEndDate,
    } = props;

    const [activeTab, setActiveTab] = useState('requests');

    const [phPlatformSearch, setPhPlatformSearch] = useState('all');
    const [phCompanySearch, setPhCompanySearch] = useState('all');

    const [propKey, setPropKey] = useState();
    const [propFilters, setPropFilters] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showConversationHistory = (conversationDetails, isBotConversation) => {
        selectConversation({
            id: conversationDetails.conversationId,
            companyId: conversationDetails.companyId,
            platform: conversationDetails.platform,
            userFirstName: conversationDetails.customerName,
            userThumbUrl: conversationDetails.visitorThumbUrl,
            isOperatorConversation: !isBotConversation,
            isBotConversation: isBotConversation,
            operatorConversationId: conversationDetails.id,
            botConversationId: conversationDetails.id
        });
    };

    const showFullConversationHistory = (conversationDetails) => {
        selectConversation({
            id: conversationDetails.conversationId,
            companyId: conversationDetails.companyId,
            platform: conversationDetails.platform,
            userFirstName: conversationDetails.customerName,
            userThumbUrl: conversationDetails.visitorThumbUrl,
        });
    };

    const openTrModal = (key, filters = {}) => {
        setPropFilters(filters);
        setPropKey(key);
        setIsModalOpen(true);
    };

    const closeConversationHistory = () => {
        clearSelectedConversationFromStore();
        conversation.id = null;
    };

    const features = company.tariff ? company.tariff.features : [];

    const phCompanyOptions = [
        {value: 'all', label: t({text: 'allBots', user})},
        ...company.subs.map(c => ({value: c.id, label: c.name, bot: c}))
    ]

    const phPlatformOptions = [
        {value: 'all', label: t({text: 'allPlatforms', user})},
        ...Object.entries(config.platformsMap)
            .filter(([key]) => key !== 'company')
            .map(([key, label]) => (
                {value: key.toUpperCase(), label: label}
            ))
    ]

    return (
        <div
            className="statistics-page"
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                height:'100%'
            }}
        >
            <div style={{flexShrink: 0}}>
                <Tabs
                    selectedTab={activeTab}
                    onTabChange={setActiveTab}
                    tabs={[
                        // first, because it is the tab the page opens on -
                        // landing on the second one reads as a page that lost
                        // its place
                        {label: 'requestsToOperators', value: 'requests'},
                        {label: 'requestsToBots', value: 'bots'},
                        {label: 'operators', value: 'operators'},
                        // 'graphs' is the graph builder's own page elsewhere in the panel;
                        // this tab collects whatever did not belong on the three
                        // before it, so it is named for that rather than for the
                        // two charts that happen to be on it
                        {label: 'other', value: 'graphs'},
                    ]}
                />
            </div>

            {/* full width: the page's own inset is the only one. maxWidth 95%
                with auto margins took another 2.5% off each side, which on a
                wide screen is a good deal more than the inset itself. */}
            <div style={{
                minHeight: '0',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '12px',
                justifyContent: 'space-between',
                overflowY: 'auto',
                padding: '4px 4px 0 4px',
                margin: '0 -4px',
            }}>

                {activeTab === 'bots' && (
                    company &&
                    <BotRequestsStatistics
                        tariff={company.tariff}
                        user={user}
                        companyInfoList={companyInfoList}
                        company={company}
                        openTrModal={openTrModal}
                    />
                )}

                {activeTab === 'requests' && (
                    <OperatorsRequestsStatistics
                        isFetchingNumbers={isFetchingNumbers}
                        statNumbers={statNumbers}
                        openTrModal={openTrModal}
                        isFetchingCompanyInfo={isFetchingCompanyInfo}
                        companyInfoList={companyInfoList}
                        company={company}
                        tariff={company.tariff}
                        user={user}
                    />
                )}

                {activeTab === 'operators' && (
                    <React.Fragment>
                        <div className="stat-section">
                            <div className="stat-section__head">
                                <h2 className="stat-section__title"><Translate text={'operators'}/></h2>
                            </div>
                            {
                                company
                                &&
                                <OperatorsTable
                                    openTrModal={openTrModal}
                                    company={company}
                                    tariff={company.tariff}
                                    user={user}
                                />
                            }
                        </div>

                        <div className="stat-section">
                            <div className="stat-section__head">
                                <h2 className="stat-section__title"><Translate text={'operatorsWorkingTime'}/></h2>
                            </div>

                            <div style={{marginBottom: '55px'}}>
                                <OperatorWorkingHours
                                    whEndDate={whEndDate}
                                    whStartDate={whStartDate}
                                    user={user}
                                    setWhStartDate={setWhStartDate}
                                    setWhEndDate={setWhEndDate}
                                    operatorWorkTimeData={operatorsWorkTimeData}
                                />
                            </div>

                        </div>

                        <div className="stat-section">
                            <div className="stat-section__head">
                                <h2 className="stat-section__title"><Translate text={'operatorLoginLogoutStatistics'}/>
                                </h2>
                            </div>
                            {
                                company
                                &&
                                <OperatorsLoginLogoutTable
                                    user={user}
                                    company={company}
                                />
                            }
                        </div>

                    </React.Fragment>
                )}

                {activeTab === 'graphs' && (
                    <React.Fragment>
                        <div className="stat-section">
                            <div className="stat-section__head">
                                <h2 className="stat-section__title"><Translate text={'peakHoursStatistics'}/></h2>
                            </div>
                            <div style={{display: 'flex', gap: '10px', marginBottom: '20px'}}>
                                <DropdownSelect
                                    selectedValue={phCompanyOptions.find(o => o.value === phCompanySearch)}
                                    onChange={v => {
                                        setPhCompanySearch(v.value);
                                        filterPeakHoursData(v.value, phPlatformSearch)
                                    }}
                                    options={phCompanyOptions}
                                    variant={'outline'}
                                    styles={{width: '300px'}}
                                >
                                    {option => (
                                        <div style={{display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0}}>
                                            {option.bot && <BotAvatar client={option.bot} size={26} imgSize={24}/>}
                                            <span style={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                minWidth: '0',
                                            }}>{option.label}</span>
                                        </div>
                                    )}
                                </DropdownSelect>

                                <DropdownSelect
                                    selectedValue={phPlatformOptions.find(o => o.value === phPlatformSearch)}
                                    onChange={v => {
                                        setPhPlatformSearch(v.value);
                                        filterPeakHoursData(phCompanySearch, v.value);
                                    }}
                                    options={phPlatformOptions}
                                    variant={'outline'}
                                    styles={{width: '300px'}}
                                >
                                    {option => (
                                        <div style={{display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0}}>
                                            {option.value !== 'all' && (
                                                <PlatformIcon conversation={{platform: option.value}} size={22}/>
                                            )}
                                            <span>{option.label.charAt(0).toUpperCase() + option.label.slice(1).toLowerCase()}</span>
                                        </div>
                                    )}
                                </DropdownSelect>
                            </div>
                            <PeakHoursStatistics data={peakHoursStatisticsData} user={user}/>
                        </div>

                        {features.includes(config.features.CATEGORIES) && (
                            <div className="stat-section">
                                <div className="stat-section__head">
                                    <h2 className="stat-section__title"><Translate text={'categoriesStatistics'}/></h2>
                                </div>
                                <CategoriesStatistics categoriesStatisticsData={categoriesStatisticsData} user={user}/>
                            </div>
                        )}

                    </React.Fragment>
                )}

                {!!conversation.id &&
                    <SelectedConversationHistory
                        isOpen={!!conversation.id}
                        company={company}
                        tariff={company.tariff}
                        conversation={conversation}
                        user={user}
                        loadOlderMessages={loadOlderMessages}
                        closeWindow={closeConversationHistory}
                    />
                }

                {/*important case*/}
                {isModalOpen &&
                    <StatisticsConvModal
                        isOpen={isModalOpen}
                        cancelAction={() => setIsModalOpen(false)}
                        user={user}
                        company={company}
                        showConversationHistory={showConversationHistory}
                        showFullConversationHistory={showFullConversationHistory}
                        header={propKey}
                        filters={propFilters}
                    />
                }

            </div>
        </div>
    );
}

Statistics2.propTypes = {};

const mapStateToProps = (state) => ({
    conversation: state.chat.conversation,
});

const mapDispatchToProps = (dispatch) => ({
    selectConversation: (conversation) => {
        dispatch(selectConversationRequested(conversation));
    },
    loadOlderMessages: () => {
        dispatch(loadOlderMessagesRequested());
    },
    clearSelectedConversationFromStore: () => {
        dispatch(clearSelectedConversationFromStore());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Statistics2);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/statistics/Statistics2.jsx